import React from "react";
import { PiBellFill } from "react-icons/pi";
import { LineWave } from "react-loader-spinner";
import { useQuery } from "react-query";
import { NotificationData } from "src/modules/fithub-shared/notifications/index.types";
import api from "src/rest/api";
import NotFeedback from "./NotContent/feedback";

const NotificationsCard: React.FC = () => {
  const content = useQuery("Notifications-card", () =>
    api
      .post<NotificationData[]>("/dashboard/notifications")
      .then((res) => res.data)
      .catch(() => []),
  );

  const NotificationContent = (not: NotificationData) => {
    switch (not.type) {
      default:
        return <p></p>;
      case "FEEDBACK":
        return <NotFeedback e={not} />;
    }
  };

  return (
    <div className="middle-card">
      <h4 className="card-title">Notificações</h4>

      {content.data && content.data.length > 0 ? (
        <ul className="flex h-full flex-col space-y-2 overflow-y-scroll">
          {content.data.map((e, i: number) => (
            <li
              key={i}
              className="flex items-center justify-between border-b border-zinc-200 py-2 last:border-none"
            >
              {NotificationContent(e)}
            </li>
          ))}
        </ul>
      ) : (
        <div className="flex flex-col items-center justify-center text-zinc-600">
          {content.isLoading ? (
            <LineWave height={60} width={60} color="#000" />
          ) : (
            <div className="m-auto flex flex-col items-center">
              <PiBellFill className="text-2xl" />
              <h5 className="text-sm">Sem Notificações!</h5>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationsCard;
